export default "__VITE_ASSET__BZDILvSe__"